import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './confirm-modal.component.html',
})
export class ConfirmModalComponent {
  readonly activeModal = inject(NgbActiveModal);

  title = '';
  body = '';
  positive = 'Ja';
  negative = 'Nee';
}
